var _circle, _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#7D7878"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4059_63929",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8H32V32H8V8Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8H32V32H8V8Z",
    stroke: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4059_63929)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9491 20.9057H19.8006C18.3318 20.8892 17.16 20.3776 16.3019 19.3874C14.3875 17.2419 14.701 13.5451 14.734 13.1986C14.8661 10.525 16.1368 9.27076 17.1765 8.67664C18.2163 8.08252 19.289 8 19.8501 8H19.9326C20.9393 8.0165 21.8305 8.24755 22.6062 8.69314C23.6294 9.28727 24.8836 10.5415 25.0157 13.1986C25.0487 13.5451 25.3622 17.2419 23.4478 19.3874C22.5897 20.3776 21.4014 20.8892 19.9491 20.9057ZM16.0711 13.2803V13.3133C16.0546 13.3463 15.7246 16.746 17.2924 18.5118C17.9195 19.205 18.7612 19.5516 19.8504 19.5681H19.8999C20.9891 19.5516 21.8308 19.205 22.4579 18.5118C23.9658 16.7977 23.7029 13.6029 23.6806 13.3315C23.6797 13.3207 23.6792 13.3145 23.6792 13.3133V13.2803C23.5142 9.91356 21.2367 9.36894 19.8999 9.33594H19.8504C18.7612 9.33594 16.2362 9.71552 16.0711 13.2803Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0634 27.0285V27.012C30.0634 26.979 30.0634 26.946 30.0634 26.8965C30.0304 25.9063 29.9643 23.6123 27.8189 22.8861C27.8024 22.8696 27.7859 22.8696 27.7694 22.8696C25.5249 22.292 23.66 21.0047 23.6435 20.9882C23.3465 20.7737 22.9339 20.8562 22.7193 21.1533C22.5048 21.4503 22.5708 21.8794 22.8844 22.0775C22.9669 22.1435 24.9308 23.5133 27.4063 24.1569C28.5616 24.5695 28.6936 25.8072 28.7266 26.9295C28.7266 26.979 28.7266 27.012 28.7431 27.0615C28.7431 27.5071 28.7101 28.2002 28.6276 28.5963C27.8189 29.0419 24.6667 30.6262 19.8808 30.6262C15.1113 30.6262 11.9261 29.0419 11.1174 28.5798C11.0514 28.1837 11.0184 27.5071 11.0184 27.0615C11.0184 27.012 11.0184 26.979 11.0184 26.9295C11.0679 25.7907 11.1835 24.5695 12.3387 24.1569C14.8142 23.5133 16.7946 22.127 16.8771 22.0775C17.1742 21.8629 17.2567 21.4503 17.0422 21.1533C16.8276 20.8397 16.415 20.7737 16.1015 20.9882C16.085 21.0047 14.2366 22.292 11.9921 22.8531C11.9756 22.8696 11.9591 22.8696 11.9426 22.8696C9.78066 23.6123 9.71465 25.9063 9.68164 26.8965C9.68164 26.9295 9.68164 26.979 9.68164 27.012V27.0285C9.68164 27.2925 9.68164 28.6128 9.9457 29.273C9.99521 29.405 10.0777 29.5205 10.1932 29.5865C10.3418 29.6855 13.9065 31.963 19.8808 31.963C25.855 31.963 29.4197 29.6855 29.5683 29.5865C29.6838 29.5205 29.7828 29.405 29.8323 29.273C30.0799 28.6128 30.0799 27.2925 30.0634 27.0285Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.109be803221e90b41a5b1e77232b6339.svg";
export { ForwardRef as ReactComponent };